var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 180.428,
    height: 41.764,
    viewBox: "0 0 180.428 41.764",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M91.3,10.443h6.266V3.4H91.3Z",
    transform: "translate(-49.631 -2.211)",
    fill: "#fdbf2d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M91.3,45.808h6.266V23.9H91.3Z",
    transform: "translate(-49.631 -13.38)",
    fill: "#646261"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M124.823,45.462V31.284a1.38,1.38,0,0,0-1.555-1.555,12.181,12.181,0,0,0-4.665,1.555V45.462h-6.4V24.012h4.757l.686,1.647a21.879,21.879,0,0,1,8.644-2.058,4.231,4.231,0,0,1,3.979,2.058,20.771,20.771,0,0,1,8.69-2.058c3.7,0,4.985,2.744,4.985,6.861v15h-6.4V31.284a1.38,1.38,0,0,0-1.555-1.555,12.181,12.181,0,0,0-4.665,1.555V45.462h-6.495Zm28.586-5.58a18.624,18.624,0,0,0,4.071.549,2.125,2.125,0,0,0,2.333-2.424V31.512c0-1.509-.64-2.424-2.333-2.424a6.848,6.848,0,0,0-4.071,1.692Zm12.806-1.921c0,5.077-2.241,7.912-7.272,7.912a29.74,29.74,0,0,1-5.534-.595v9.742h-6.4V24.012h5.031l.686,1.738A14.073,14.073,0,0,1,159.4,23.6c4.391,0,6.861,2.7,6.861,7.912Z",
    transform: "translate(-61.033 -13.258)",
    fill: "#646261"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M235.8,34.5V3.4h6.4V34.5Z",
    transform: "translate(-128.181 -2.211)",
    fill: "#646261"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M256.5,10.169h6.4V3.4h-6.4Z",
    transform: "translate(-139.434 -2.211)",
    fill: "#fdbf2d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    transform: "translate(117.037 1.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M256.7,45.865h6.4V24.5h-6.4Z",
    transform: "translate(-256.7 -14.895)",
    fill: "#646261"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M289.127,9.034a16.317,16.317,0,0,0-2.836-.32c-2.058,0-2.2.869-2.2,2.287v2.516h5.123l-.457,5.214H284.1V34.555h-6.4V18.73H274.4V13.562h3.293v-3.2c0-4.391,2.1-6.861,7.318-6.861a24.694,24.694,0,0,1,4.894.595Z",
    transform: "translate(-266.304 -3.5)",
    fill: "#646261"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M313.82,54.641l2.515-8.69h-2.058L307.6,24.5h6.495l4.391,15.185L322.876,24.5h6.495l-6.815,21.451-2.744,8.69Z",
    transform: "translate(-284.32 -14.981)",
    fill: "#646261"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M368.068,37.515H365c-1.372,0-1.921.364-1.921,1.549s.5,1.686,1.738,1.686a7.751,7.751,0,0,0,3.247-.729Zm1.189,7.7-.457-1.367a13.168,13.168,0,0,1-6.175,1.777c-4.025,0-5.626-2.87-5.626-6.515,0-4.283,2.012-6.014,6.449-6.014h4.665v-1.64c0-2.187-.412-2.962-3.842-2.962a32.711,32.711,0,0,0-5.854.592l-.823-4.738A32.05,32.05,0,0,1,365.37,23.3c7.5,0,9.147,2.233,9.147,8.156V45.124h-5.26Z",
    transform: "translate(-311.126 -14.244)",
    fill: "#646261"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M72.193,32.341a43.265,43.265,0,0,0-6.632-.64C63.5,31.7,63,32.2,63,33.164c0,1.326.183,1.509,3.064,2.1,4.894,1.006,6.54,1.967,7.089,4.025a19.045,19.045,0,0,0-.686-9.193Z",
    transform: "translate(-34.248 -16.734)",
    fill: "#fdbf2d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M30.324,33.293a36.7,36.7,0,0,1-8.736-1.278l1.143-4.746A28.081,28.081,0,0,0,30,28.227c2.1,0,2.47-.548,2.47-1.825,0-1.369-.046-1.552-3.888-2.419-5.809-1.278-6.357-2.738-6.357-6.754,0-4.609,1.967-6.526,9.193-6.526a45.889,45.889,0,0,1,5.626.411A19.893,19.893,0,0,0,19.621.8,19.5,19.5,0,0,0,0,20.2a19.5,19.5,0,0,0,19.621,19.4A19.82,19.82,0,0,0,34.44,32.928a20.841,20.841,0,0,1-4.116.365",
    transform: "translate(0 -0.8)",
    fill: "#fdbf2d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8b2bbf2abf891fd231e2586e6219109b.svg";
export { ForwardRef as ReactComponent };